import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgShieldProtected3 = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Shield_Protected.3",
	"data-name": "Shield, Protected.3",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12829",
			"data-name": "Path 12829",
			d: "M0,0H24V24H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12830",
			"data-name": "Path 12830",
			d: "M7,13.5h3",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12831",
			"data-name": "Path 12831",
			d: "M7,17h3",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12832",
			"data-name": "Path 12832",
			d: "M10,21H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H17a2,2,0,0,1,2,2V9",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12834",
			"data-name": "Path 12834",
			d: "M7,8.7V6.5h4V8.7L9,10.3Z",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12835",
			"data-name": "Path 12835",
			d: "M12,14.031,16,12l4,2.031V17a4,4,0,0,1-8,0Z",
			transform: "translate(1)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5
		})
	]
});
export default SvgShieldProtected3;
